
export interface EtlQueue {
    name: string;
    deleteProcessedDocuments: boolean;
}
